// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgChargingBoostIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M9.8 10.4a1 1 0 1 1-1.6 1.2l-3-4a1 1 0 1 1 1.6-1.2zm4.4 0a1 1 0 1 0 1.6 1.2l3-4a1 1 0 1 0-1.6-1.2z" />
    <path
      fillRule="evenodd"
      d="M12 6a8 8 0 1 1 0 16 8 8 0 0 1 0-16m.688 4.035a.51.51 0 0 0-.59.16l-3 4.001c-.11.15-.13.35-.05.52a.5.5 0 0 0 .451.28h1.81l-.3 2.44a.505.505 0 0 0 .9.37l3-4c.11-.15.13-.35.05-.52a.5.5 0 0 0-.45-.28h-1.81l.3-2.441c.03-.23-.1-.44-.31-.53"
      clipRule="evenodd"
    />
    <path d="M15 2a1 1 0 1 1 0 2H9a1 1 0 0 1 0-2z" />
  </g>
);
export default SvgChargingBoostIcon;
SvgChargingBoostIcon.displayName = 'SvgChargingBoostIcon';
